import React from 'react';

function TrusteeRegistrarServices() {
  return (
    <main className="bg-white">
      <section className="relative h-[42vh] min-h-[320px] flex items-center justify-center overflow-hidden">
        <img src="/images/real-people/inspiring-innovation-with-their-every-move-cropped-shot-group-businesspeople-working-together-office_590464-10869.jpg" alt="Trustee & Registrar Services" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 text-center px-6">
          <h1 className="text-white text-4xl sm:text-5xl font-semibold tracking-tight">Trustee & Registrar Services</h1>
          <p className="mt-3 text-white/90 max-w-2xl mx-auto">Independent oversight and record-keeping for funds, schemes, and issuers.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">Oversight</h2>
            <p className="mt-4 text-gray-600">We monitor mandate compliance, NAV calculations, and investor communications with meticulous standards and timely reporting to relevant stakeholders.</p>
            <ul className="mt-6 space-y-3 text-gray-700 list-disc list-inside">
              <li>Unit registry and corporate actions</li>
              <li>Custody liaison and reconciliation</li>
              <li>Regulatory filings and disclosures</li>
            </ul>
          </div>
          <img src="/images/real-people/business-people-tablet-plan-consulting-office-collaboration-unity-proposal-coworkers-workplace-teamwork-reading-report-support-online-review-networking_590464-305736.jpg" alt="Oversight" className="w-full h-80 object-cover rounded-xl shadow" />
        </div>
      </section>

      <section className="py-14 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          {[
            { t: 'Registrar', d: 'Investor registry, statements, and query handling.' },
            { t: 'Trustee', d: 'Independent checks, NAV review, and mandate adherence.' },
            { t: 'Issuance', d: 'Support for offers, allotments, and distributions.' }
          ].map((x) => (
            <div key={x.t} className="rounded-xl bg-white p-6 shadow border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900">{x.t}</h3>
              <p className="mt-2 text-gray-600 text-sm">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Who We Serve */}
      <section className="py-14 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          {[
            { t: 'Mutual Funds & ETFs', d: 'Independent oversight and registrar for pooled investment vehicles.' },
            { t: 'Pension & Provident', d: 'Trustee services aligned to scheme rules and regulatory standards.' },
            { t: 'Corporate Issuers', d: 'Share registers, corporate actions, and meeting administration.' }
          ].map((x) => (
            <div key={x.t} className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm hover:shadow-md transition duration-300">
              <h3 className="text-lg font-semibold text-gray-900">{x.t}</h3>
              <p className="mt-2 text-gray-600 text-sm">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Core Capabilities with imagery */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <img src="/images/real-people/team-diversity-accountants-portrait-office-meeting-finance-strategy-table-with-laptop-woman-men-business-people-together-boardroom-collaboration-partnership-support_590464-373758.jpg" alt="Registry Platform" className="w-full h-96 object-cover rounded-xl shadow" />
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">Core Capabilities</h2>
            <ul className="mt-6 space-y-3 text-gray-700">
              <li className="flex gap-3"><span className="h-2.5 w-2.5 mt-2 rounded-full bg-green-500" />Real‑time investor registry with KYC and account maintenance</li>
              <li className="flex gap-3"><span className="h-2.5 w-2.5 mt-2 rounded-full bg-green-500" />NAV verification, mandate checks, pricing circularization</li>
              <li className="flex gap-3"><span className="h-2.5 w-2.5 mt-2 rounded-full bg-green-500" />Corporate actions, distributions, and reconciliation</li>
              <li className="flex gap-3"><span className="h-2.5 w-2.5 mt-2 rounded-full bg-green-500" />Investor reporting, statements, and service desk SLAs</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-2xl font-semibold text-gray-900">Our Process</h2>
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { t: 'Onboarding', d: 'Mandate review, registers migration, controls mapping.' },
              { t: 'Go‑Live', d: 'Parallel run, reconciliation, and sign‑off.' },
              { t: 'Operate', d: 'Daily checks, event handling, investor support.' },
              { t: 'Review', d: 'Monthly KPIs, quarterly audits, enhancements.' }
            ].map((x, i) => (
              <div key={x.t} className="rounded-xl bg-white border border-gray-100 p-6 shadow-sm hover:-translate-y-0.5 hover:shadow-lg transition duration-300">
                <div className="h-9 w-9 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-semibold">{i + 1}</div>
                <h3 className="mt-4 text-base font-semibold text-gray-900">{x.t}</h3>
                <p className="mt-1.5 text-sm text-gray-600">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology & Reporting */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">Technology & Reporting</h2>
            <p className="mt-4 text-gray-600">Secure, auditable workflows with clear evidence trails. Clients receive dashboards and downloadable reports tailored to regulators and boards.</p>
            <div className="mt-6 grid sm:grid-cols-2 gap-4">
              {[
                'Role‑based access',
                'Audit logs',
                'Automated statements',
                'Regulatory packs'
              ].map((x) => (
                <div key={x} className="rounded-xl border border-green-100 bg-green-50 p-4 text-gray-800 text-sm font-medium">{x}</div>
              ))}
            </div>
          </div>
          <img src="/images/real-people/business-education-concept-group-people-international-conference_380164-184068.jpg" alt="Reporting" className="w-full h-96 object-cover rounded-xl shadow" />
        </div>
      </section>

      {/* SLAs & Compliance */}
      <section className="py-14 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          {[
            { t: 'Service Levels', d: 'Time‑bound responses for investor queries and corporate actions.' },
            { t: 'Compliance', d: 'Regulatory filings, board reporting, and periodic attestations.' },
            { t: 'Business Continuity', d: 'Backups, DR testing, and operational resilience plans.' }
          ].map((x) => (
            <div key={x.t} className="rounded-xl bg-white p-6 shadow border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900">{x.t}</h3>
              <p className="mt-2 text-gray-600 text-sm">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQs */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="text-2xl font-semibold text-gray-900">FAQs</h2>
          <div className="mt-6 space-y-3">
            {[
              { q: 'Can you migrate an existing register?', a: 'Yes. We run parallel reconciliation and obtain registrar and client sign‑offs.' },
              { q: 'Do you support electronic meetings?', a: 'We administer hybrid/virtual meetings and proxy collection with verifiable tallies.' },
              { q: 'What reporting do boards receive?', a: 'Compliance confirmations, NAV checks, breaches log, and investor statistics.' },
              { q: 'How are distributions handled?', a: 'End‑to‑end workflow: entitlement calc, approvals, payment files, and confirmation.' }
            ].map((x) => (
              <details key={x.q} className="group rounded-lg border border-gray-100 p-4 open:bg-gray-50 transition">
                <summary className="list-none cursor-pointer select-none flex items-center justify-between">
                  <span className="font-medium text-gray-900">{x.q}</span>
                  <span className="text-gray-400 group-open:rotate-180 transition">▾</span>
                </summary>
                <p className="mt-2 text-sm text-gray-600">{x.a}</p>
              </details>
            ))}
          </div>
          <p className="mt-6 text-xs text-gray-500">Services are subject to applicable regulations. This page is for information only and not a solicitation.</p>
        </div>
      </section>

      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-3xl font-semibold">Request trustee/registrar support</h3>
          <p className="mt-2 text-white/80">We’ll tailor a scope to your fund or issuance needs.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <a href="/apply" className="px-6 py-3 rounded-md bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] text-black font-semibold">Apply now</a>
            <a href="/contact" className="px-6 py-3 rounded-md border border-white/30">Contact us</a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TrusteeRegistrarServices;
